import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane,  } from "@fortawesome/free-solid-svg-icons";
import "./home.scss";
import api from "../../../utils/axiosPublic";

const ContactForm = ({ slug }) => {
  const form = useRef();
  
  const navigate = useNavigate();

  const [error, setError] = useState({
    phone: "",
    message: "",
    fullName: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const sendEmail = async (e) => {
    if (form.current.phone.value.toString().length > 9) {
      const success = await handleSaveCustomer();
      if (success) {
        navigate("/dang-ky-thanh-cong");
        toast(`Đăng ký thành công`, {
          type: "success",
          autoClose: 1000,
          style: { marginTop: "50px" },
        });
      } else {
        toast(`Đăng ký thất bại`, {
          type: "error",
          autoClose: 1000,
          style: { marginTop: "50px" },
        });
      }
    } else {
      toast(`Vui lòng nhập số điện thoại`, {
        type: "error",
        autoClose: 1000,
        style: { marginTop: "50px" },
      });
    }
  };

  const handleSaveCustomer = async () => {
    const fullName = form.current.user_name.value.toString();
    const phone = form.current.phone.value.toString();
    const message = form.current.message.value.toString();

    const data = {
      fullName: fullName,
      phone: phone,
      message: message,
      slug: slug,
    };

    try {
      setIsLoading(true);
      const res = await api.post(`/customer/create`, data);
      if (res.data.errCode === 0) {
        return true;
      }
    } catch (error) {
     setError(error.response?.data?.messages);
    }

    setIsLoading(false);
    return false;
  };

  return (
    <Card bg="light">
      <Card.Body className="p-4">
        <p className="text-gradient text-center">
          Chi phí áp dụng phần mềm kafood vào quản lý mầm non chỉ từ
          150k/tháng. Đăng ký ngay!
        </p>
        <Form ref={form} onSubmit={() => sendEmail()}>
          <Row>
            <Col>
              <Form.Floating className="mb-3">
                <Form.Control
                  type="text"
                  name="user_name"
                  placeholder="Tên của bạn"
                  required
                  isInvalid={error?.fullName}
                  onChange={(e) => setError({ ...error, fullName: "" })}
                  className="form-contact"
                />
                <Form.Label>
                  Tên của bạn<i className="text-danger"></i>
                </Form.Label>
                <i className="text-danger">{error?.fullName}</i>
              </Form.Floating>
            </Col>
          </Row>
          <Form.Floating className="mb-3">
            <Form.Control
              type="text"
              name="phone"
              placeholder="Số điện thoại"
              required
              isInvalid={error?.phone}
              onChange={(e) => setError({ ...error, phone: "" })}
              className="form-contact"
            />
            <Form.Label>
              Số điện thoại<i className="text-danger">*</i>
            </Form.Label>
            <i className="text-danger">{error?.phone}</i>
          </Form.Floating>
          <Form.Floating className="mb-3">
            <Form.Control
              as="textarea" 
              type="text"
              placeholder="Lời nhắn"
              name="message"
              className="form-contact"
              isInvalid={error?.message}
              onChange={(e) => setError({ ...error, message: "" })}
            />
            <Form.Label>Lời nhắn</Form.Label> 
            <i className="text-danger">{error?.message}</i>
          </Form.Floating>
          <Form.Floating className="mb-3" hidden>
            <Form.Control
              type="text"
              placeholder="slug"
              name="slug"
              className="form-contact"
            />
          </Form.Floating>
          <center>
            <Button
              variant="success"
              onClick={() => sendEmail()}
              className="text-center"
            >
              {isLoading ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={faPaperPlane} />} Đăng ký tư vấn miễn phí
            </Button>
          </center>
        </Form>
      </Card.Body>  
    </Card>
  );
};

export default ContactForm;
